import { createContext, useContext, useEffect, useState } from "react";

const ThemeCtx = createContext(null);

function isNightByClock() {
  const h = new Date().getHours();
  // Night 18:00 – 05:59
  return h >= 18 || h < 6;
}

export function ThemeProvider({ children }) {
  const [mode, setMode] = useState(() => (isNightByClock() ? "night" : "day"));
  const [auto, setAuto] = useState(true);

  // Auto re-check every 60s when auto is on
  useEffect(() => {
    if (!auto) return;
    const tick = () => {
      const next = isNightByClock() ? "night" : "day";
      setMode((m) => (m !== next ? next : m));
    };
    tick();
    const id = setInterval(tick, 60_000);
    return () => clearInterval(id);
  }, [auto]);

  // Apply class to root
  useEffect(() => {
    const root = document.documentElement;
    if (mode === "night") root.classList.add("theme-night");
    else root.classList.remove("theme-night");
  }, [mode]);

  const toggle = () => {
    setAuto(false);
    setMode((m) => (m === "day" ? "night" : "day"));
  };

  return (
    <ThemeCtx.Provider value={{ mode, auto, toggle }}>
      {children}
    </ThemeCtx.Provider>
  );
}

export function useTheme() {
  const ctx = useContext(ThemeCtx);
  if (!ctx) throw new Error("useTheme must be used within ThemeProvider");
  return ctx;
}
